import { useMutation } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IPartAiConditionResponse } from "../models/Part";

export default function usePartAiCondition() {
  const { post } = useApiHelper();

  const generateAiCondition = useMutation((partId: string) =>
    post<null, IPartAiConditionResponse>(`/part/listing/ai-condition/${partId}`, null)
  );

  return {
    generateAiCondition,
  };
}
